import { Link } from "react-router-dom";
import { Instagram, Lock, MessageCircle } from "lucide-react";
import { INSTAGRAM_URL, LOGO_URL, WA_TATTOO } from "../../lib/constants";

export const Footer = () => (
  <footer className="bg-[#0A0A0A] border-t border-white/10 px-6 pt-20 pb-8" data-testid="main-footer">
    <div className="max-w-7xl mx-auto">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-12 pb-14">
        <div>
          <img src={LOGO_URL} alt="Diggy Shop" className="h-14 w-auto mb-6" />
          <p className="text-sm font-light text-white/50 leading-relaxed max-w-xs">
            Tattoo, piercing, joias e acessórios. Uma instituição de Jundiaí desde 1998.
          </p>
        </div>
        <div>
          <p className="text-xs tracking-[0.3em] font-bold text-white/40 mb-5">NAVEGAÇÃO</p>
          <nav className="flex flex-col gap-3">
            {[["ESTÚDIO", "#manifesto"], ["PORTFÓLIO", "#portfolio"], ["PIERCING & JOIAS", "#piercing"], ["ORÇAMENTO", "#orcamento"]].map(([label, href]) => (
              <a key={href} href={href} data-testid={`footer-link-${label.toLowerCase().replace(/[^a-z]/g, "-")}`} className="text-sm text-white/60 hover:text-[#E60000] transition-colors duration-300 w-fit">
                {label}
              </a>
            ))}
          </nav>
        </div>
        <div>
          <p className="text-xs tracking-[0.3em] font-bold text-white/40 mb-5">FALE COM A DIGGY</p>
          <div className="flex items-center gap-3">
            <a
              href={WA_TATTOO}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-whatsapp-button"
              className="btn-sharp inline-flex items-center gap-2 bg-[#E60000] hover:bg-white hover:text-[#0A0A0A] text-white text-xs tracking-[0.15em] font-extrabold px-6 py-4 transition-colors duration-300"
            >
              <MessageCircle size={14} /> CHAMAR NO WHATSAPP
            </a>
            <a
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram-link"
              aria-label="Instagram da Diggy Shop"
              className="flex items-center justify-center w-12 h-12 border border-white/20 text-white/70 hover:border-[#E60000] hover:text-[#E60000] transition-colors duration-300"
            >
              <Instagram size={18} />
            </a>
          </div>
          <p className="mt-4 text-xs tracking-[0.15em] text-white/40">@diggyshop__</p>
          <p className="mt-5 text-sm text-white/50">R. Barão do Triunfo, 208 — Bela Vista<br />Jundiaí/SP • Desde 1998</p>
        </div>
      </div>

      <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-xs text-white/30">© {new Date().getFullYear()} DIGGY SHOP. Todos os direitos reservados.</p>
        <Link
          to="/admin"
          data-testid="footer-admin-link"
          className="flex items-center gap-2 text-xs tracking-[0.15em] text-white/30 hover:text-[#E60000] transition-colors duration-300"
        >
          <Lock size={12} /> ACESSO RESTRITO
        </Link>
      </div>
    </div>
  </footer>
);
